import {FC, ReactNode} from "react";
import {ContentContainer} from "../../../../lib/src/components/content/ContentContainer";
import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import {SectionDivider} from "../../../../lib/src/components/content/SectionDivider";
import {useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import DataTable from "../../../../lib/src/components/data-table/DataTable";
import {Button} from "../../../../lib/src/components/form/Button";
import {faPencil, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {AddCallbackTemplateModal} from "../../modals/AddCallbackTemplateModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {CallbackRequestTemplate} from "../../../../lib/src/api/repositories/telephone-repository";
import {EditCallbackTemplateModal} from "../../modals/EditCallbackTemplateModal";
import {DeleteCallbackTemplateModal} from "../../modals/DeleteCallbackTemplateModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export default function CallbackTemplatesSettingsPage(): ReactNode {
  const { telephone: telephoneApi } = useApiCall(config)
  const { resource: templates, isLoading, reload} = useApiEndpoint(() => telephoneApi.browseCallbackTemplates())
  const addModal = useModal({title: 'Terugbel sjabloon toevoegen', body: <AddCallbackTemplateModal onFinished={reload} />, size: 'lg'})
  return <ContentContainer>
    <PageHeader>Telefooncentrale</PageHeader>

    <p>
      Terugbel sjablonen voor de telefooncentrale. Hier kunnen de sjablonen voor terugbellen ingesteld en beheerd worden.
    </p>

    <SectionDivider />

    <div className={'flex flex-row justify-between'}>
      <PageHeader>Terugbel sjablonen</PageHeader>
      <Button type={'primary'} size={'sm'} text={'Sjabloon toevoegen'} icon={faPlus} onClick={() => addModal.open()} />
    </div>

    {(templates && templates?.length > 0) ? <DataTable keyProperty={'id'} placeholder={'Geen sjablonen'} data={templates ?? []} columns={[
      {
        property: 'name',
        header: 'Onderwerp'
      },
      {
        property: 'text',
        header: 'Inhoud',
        transform: (_, row) => <div>{row.text.slice(0, 100)}...</div>
      },
      {
        property: 'id',
        header: 'Acties',
        transform: (_, row) => {
          return <TableOptions callbackRequest={row} reload={reload} />
        }
      }
    ]
    }
    /> :
      <div className={'bg-white border border-slate-200 rounded-sm py-4 flex flex-col items-center justify-center'}>
        <div>Momenteel zijn er nog geen sjablonen toegevoegd</div>
        <div className={'text-xs'}>Voeg er een toe door
          <span className={'text-brand-700 underline hover:text-brand-500 hover:cursor-pointer'} onClick={() => addModal.open()}> hier </span>
          of op de toevoegen knop boven de tabel te klikken
        </div>
      </div>
    }
  </ContentContainer>
}

const TableOptions: FC<{ callbackRequest: CallbackRequestTemplate, reload: () => void }> = (props) => {
  const editModal = useModal({title: 'Terugbel sjabloon bewerken', body: <EditCallbackTemplateModal callbackRequest={props.callbackRequest} onFinished={props.reload}/>, size: 'md'})
  const deleteModal = useModal({title: 'Terugbel sjabloon verwijderen', body: <DeleteCallbackTemplateModal callbackRequest={props.callbackRequest} onFinished={props.reload}/>, size: 'md'})
  return <div className={'flex space-x-3 w-10 mr-4'}>
    <div className={'text-blue-700 underline hover:text-blue-500 hover:cursor-pointer hover:bg-blue-100 rounded-sm px-1.5 py-0.5'}
         onClick={() => editModal.open()}>
      <FontAwesomeIcon icon={faPencil} />
    </div>
    <div className={'text-brand-700 underline hover:text-brand-500 hover:cursor-pointer hover:bg-red-100 rounded-sm px-1.5 py-0.5'}>
      <FontAwesomeIcon icon={faTrash} onClick={() => deleteModal.open()} />
    </div>
  </div>
}